import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function CTAFinal() {
  return <Section background="white" className="text-center" data-id="element-82">
      <h2 className="text-3xl md:text-5xl font-bold text-stone-900 mb-8 leading-tight" data-id="element-83">
        Descargalo ahora y cerrá la semana hoy.
        <br data-id="element-84" />
        <span className="text-emerald-800" data-id="element-85">
          Basta de pelearte con la heladera.
        </span>
      </h2>

      <div className="flex flex-col items-center gap-4" data-id="element-86">
        <Button fullWidth className="md:w-auto text-xl px-12 py-6 shadow-2xl shadow-emerald-900/20" data-id="element-87">
          Quiero Semana Resuelta + Bonos Gratis
        </Button>
        <p className="text-xs text-stone-400 flex items-center gap-2 mt-4" data-id="element-88">
          <span data-id="element-89">🔒 Pago seguro con MercadoPago</span>
          <span data-id="element-90">•</span>
          <span data-id="element-91">🛡️ Garantía 7 días</span>
        </p>
      </div>
    </Section>;
}